export default __webpack_public_path__ + "static/media/Frame 23.7253f3e0.svg";